const KEY = 'terroir_filter_pc';
export const POSTAL_CODE_EVENT = 'em:postal-code-changed';
export const POSTAL_CODE_GATE_EVENT = 'em:open-postal-gate';

export function isValidBelgianPostalCode(pc) {
  return /^[1-9][0-9]{3}$/.test(String(pc || '').trim());
}

const TTL_MS = 30 * 24 * 60 * 60 * 1000; // préférence nécessaire, conservée 30 jours max

export function getPostalCode() {
  try {
    const at = Number(localStorage.getItem(`${KEY}_at`) || 0);
    if (at && Date.now() - at > TTL_MS) { localStorage.removeItem(KEY); localStorage.removeItem(`${KEY}_at`); return ''; }
    return localStorage.getItem(KEY) || '';
  } catch { return ''; }
}

export function setPostalCode(pc) {
  const clean = String(pc || '').trim();
  try {
    if (clean) { localStorage.setItem(KEY, clean); localStorage.setItem(`${KEY}_at`, String(Date.now())); }
    else { localStorage.removeItem(KEY); localStorage.removeItem(`${KEY}_at`); }
  } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent(POSTAL_CODE_EVENT, { detail: clean }));
}

export function openPostalCodeGate() {
  window.dispatchEvent(new CustomEvent(POSTAL_CODE_GATE_EVENT));
}
